import styled from "styled-components";

import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ItemContainer = styled(CenteredFlexRow)`
    gap: 8px;
`;
